import React, { useCallback, useMemo, FC } from 'react'
import { useBookingCalendar } from '../../providers/BookingCalendar'
import BookingCalendarApp from './BookingCalendarApp'
import { MODAL_VARIANTS } from '../../providers/BookingCalendar/types'
import DialogBase from './DialogBase'
import usePhoneViewPortHack from '../../hooks/usePhoneViewPortHack'

const CONTAINER_STYLE = {
  [MODAL_VARIANTS.FULL_SCREEN]: { overflow: 'visible', height: '100vh' },
  [MODAL_VARIANTS.SIDE_MODAL]: { paddingInline: '24px', paddingTop: '20px' }
}

const BookingCalendarModal: FC = () => {
  const { state, modalVariant, changeScreen } = useBookingCalendar()

  const isOpen = useMemo(() => modalVariant !== MODAL_VARIANTS.NONE, [modalVariant])

  const containerStyle = useMemo(
    () => CONTAINER_STYLE?.[modalVariant as keyof typeof CONTAINER_STYLE] || {},
    [modalVariant]
  )

  const handleClose = useCallback(() => {
    changeScreen(0)
  }, [changeScreen])

  const onReturnBackClick = useCallback(() => {
    changeScreen(state.currentScreen - 1)
  }, [changeScreen, state.currentScreen])

  usePhoneViewPortHack()

  if (!isOpen) {
    return null
  }

  return (
    <DialogBase variant={modalVariant} open={isOpen} onClose={handleClose}>
      <BookingCalendarApp onBackButtonClick={onReturnBackClick} containerStyle={containerStyle} />
    </DialogBase>
  )
}

export default BookingCalendarModal
